import { MediaManagerRenderedImageDto } from '../interfaces/supabase/media-manager/dto';
import { MediaManagerRenderedImage } from '../interfaces/supabase/media-manager/entity';

const mediaManagerRenderedImageDataMapper = (
  dto: MediaManagerRenderedImageDto,
): MediaManagerRenderedImage => {
  const { match_id, board_id, image_url, alias_match_board, created_at, updated_at, ...rest } = dto;

  return {
    ...rest,
    matchId: match_id,
    boardId: board_id,
    imageUrl: image_url,
    aliasMatchBoard: alias_match_board,
    createdAt: created_at,
    updatedAt: updated_at,
  };
};

export default mediaManagerRenderedImageDataMapper;
